import styled from 'styled-components'

import { Colors, Icon, Stack, Text } from '@doordash/design-language'

export const DeliveryIssuesIconContainer = styled.div`
  z-index: 1;
  background-color: ${Colors.SystemWhite};
  display: flex;
  align-items: center;
  justify-content: center;
`

export const StepIcon = styled(Icon)`
  height: ${Icon.Sizes.Medium};
  width: ${Icon.Sizes.Medium};
  display: flex;
  align-items: center;
`

export const TimelineWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  position: relative;
`

export const TimelineVerticalLineFirst = styled.div`
  width: 1px;
  height: calc(100% + 32px);
  top: 0px;
  position: absolute;
  background: ${Colors.SystemGrey10};
  z-index: 0;
`
export const TimelineVerticalLineLast = styled.div`
  width: 1px;
  height: 40%;
  top: -9px;
  position: absolute;
  background: ${Colors.SystemGrey10};
  z-index: 0;
`
export const TimelineVerticalLineMiddle = styled.div`
  width: 1px;
  height: calc(100% + 32px);
  top: -9px;
  position: absolute;
  background: ${Colors.SystemGrey10};
  z-index: 0;
`

export const OppositeHeadings = styled(Stack)`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`

export const CircleContainer = styled.div`
  line-height: ${Text.LineHeights.Small};
`
export const AlertIconContainer = styled.div`
  display: flex;
  width: 8px;
  // When using icons with list cell, it happens to shrink the inner icon
  // from the intended size. Large here would make it 32x32 and Medium would
  // be 24x24 by having the container be 20x20, the icon is at the correct
  // Medium at 16x16

  svg {
    width: 20px;
    height: 20px;
  }
`

export const SubmittedDetailsContainer = styled.div`
  background-color: ${Colors.SystemGrey0};
`
